import { render, staticRenderFns } from "./GroupsTable.vue?vue&type=template&id=459bc5c4&scoped=true&"
import script from "./GroupsTable.vue?vue&type=script&lang=js&"
export * from "./GroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTable.vue?vue&type=style&index=0&id=459bc5c4&lang=scss&scoped=true&"
import style1 from "./GroupsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459bc5c4",
  null
  
)

export default component.exports